import React from 'react';

const HeroSection = () => {
    return (
        <section className="w-full bg-gradient-radial pt-32 pb-12 lg:py-40">
            <div className="container mx-auto px-4 lg:px-15 flex flex-col lg:flex-row items-center gap-10">
                <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left gap-8">
                    <p className="text-sm sm:text-base lg:text-xl font-urbanist text-stone-300">
                        Be Recognised. Be Empowered. Be a Part of India’s Fitness Movement.
                    </p>
                    <h1 className="text-3xl sm:text-5xl lg:text-5xl font-bold font-urbanist text-white capitalize text-left leading-tight">
                        Become a Member –<br/> Join FWPI Today
                    </h1>
                    <p className="text-sm sm:text-base lg:text-xl font-urbanist font-semibold text-stone-300">
                        FWPI Membership is open to all fitness and wellness professionals who are committed to ethical practices, continuous learning, and industry growth. Whether you're a personal trainer, yoga instructor, nutrition coach, or wellness consultant — FWPI gives you the recognition and community you deserve.
                    </p>
                </div>
                <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
                    <img className="w-full h-auto object-cover rounded-tl-[10rem] rounded-tr-2xl rounded-bl-[10rem] rounded-br-[10rem] border-2 border-white" src="/assets/services/1/service-hero-section.jpg" alt="service-hero-section" />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;